import {apiClient} from "../../../../lib/api-client";
import image_36x21CooktopCutout from "../assets/images/36x21CooktopCutout.png"
import image_CooktopSplash from "../assets/images/CooktopSplash.png"
import image_RefrigeratorCooktop from "../assets/images/RefrigeratorCooktop.png"
import image_RangeCooktop from "../assets/images/RangeCooktop.png"
import image_DishWasherCooktop from "../assets/images/DishWasherCooktop.png"
import image_SinkSingle from "../assets/images/SinkSingle.png"
import image_Sink5050 from "../assets/images/Sink 50-50.png"
import image_Sink6040 from "../assets/images/Sink 60-40.png"
import image_Sink4060 from "../assets/images/Sink 40-60.png"
import image_Sink3070 from "../assets/images/Sink 30-70.png"
import image_Sink7030 from "../assets/images/Sink 70-30.png"

export class DrawDataLoader {
    static COOKTOP_CUTOUT_IMAGE: HTMLImageElement;
    static COOKTOP_SPLASH_IMAGE: HTMLImageElement;
    static COOKTOP_REFRIGERATOR_IMAGE: HTMLImageElement;
    static COOKTOP_RANGE_IMAGE: HTMLImageElement;
    static COOKTOP_DISHWASHER_IMAGE: HTMLImageElement;
    static SINGLE_SINK_IMAGE: HTMLImageElement;
    static SINK_IMAGE_50_50: HTMLImageElement;
    static SINK_IMAGE_60_40: HTMLImageElement;
    static SINK_IMAGE_70_30: HTMLImageElement;
    static SINK_IMAGE_40_60: HTMLImageElement;
    static SINK_IMAGE_30_70: HTMLImageElement;

    static initialize() {
        let imgTag = document.createElement("img");
        imgTag.setAttribute("src", image_36x21CooktopCutout);
        imgTag.setAttribute("alt", "36x21CooktopCutout");
        DrawDataLoader.COOKTOP_CUTOUT_IMAGE = imgTag;
        imgTag = document.createElement("img");
        imgTag.setAttribute("src", image_CooktopSplash);
        imgTag.setAttribute("alt", "CooktopSplash");
        DrawDataLoader.COOKTOP_SPLASH_IMAGE = imgTag;
        imgTag = document.createElement("img");
        imgTag.setAttribute("src", image_RefrigeratorCooktop);
        imgTag.setAttribute("alt", "RefrigeratorCooktop");
        DrawDataLoader.COOKTOP_REFRIGERATOR_IMAGE = imgTag;
        imgTag = document.createElement("img");
        imgTag.setAttribute("src", image_RangeCooktop);
        imgTag.setAttribute("alt", "RangeCooktop");
        DrawDataLoader.COOKTOP_RANGE_IMAGE = imgTag;
        imgTag = document.createElement("img");
        imgTag.setAttribute("src", image_DishWasherCooktop);
        imgTag.setAttribute("alt", "DishWasherCooktop");
        DrawDataLoader.COOKTOP_DISHWASHER_IMAGE = imgTag;
        imgTag = document.createElement("img");
        imgTag.setAttribute("src", image_SinkSingle);
        imgTag.setAttribute("alt", "SinkSingle");
        DrawDataLoader.SINGLE_SINK_IMAGE = imgTag;
        imgTag = document.createElement("img");
        imgTag.setAttribute("src", image_Sink5050);
        imgTag.setAttribute("alt", "Sink 50-50");
        DrawDataLoader.SINK_IMAGE_50_50 = imgTag;
        imgTag = document.createElement("img");
        imgTag.setAttribute("src", image_Sink6040);
        imgTag.setAttribute("alt", "Sink 60-40");
        DrawDataLoader.SINK_IMAGE_60_40 = imgTag;
        imgTag = document.createElement("img");
        imgTag.setAttribute("src", image_Sink7030);
        imgTag.setAttribute("alt", "Sink 70-30");
        DrawDataLoader.SINK_IMAGE_70_30 = imgTag;
        imgTag = document.createElement("img");
        imgTag.setAttribute("src", image_Sink4060);
        imgTag.setAttribute("alt", "Sink 40-60");
        DrawDataLoader.SINK_IMAGE_40_60 = imgTag;
        imgTag = document.createElement("img");
        imgTag.setAttribute("src", image_Sink3070);
        imgTag.setAttribute("alt", "Sink 30-70");
        DrawDataLoader.SINK_IMAGE_30_70 = imgTag;
    }

    static async getImageFromFile(path: string): Promise<HTMLImageElement | null> {
        var dataTransferObject = {path: path};
        let d = await apiClient.post("Pages/Store/QuotingTool/DrawingCanvasService.asmx/GetBase64ImgStringByPath", dataTransferObject);
        let strArr = d.data;
        if (!strArr || strArr.length < 3) {
            return null;
        }
        var imgTag = document.createElement("img");
        imgTag.setAttribute("src", "data:image/" + strArr[1] + ";base64," + strArr[2]);
        imgTag.setAttribute("alt", strArr[0]);
        return imgTag;
    }
}
